<template>
  <div class="tabs-button-header">
    <v-card class="mt-2">
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="3">
            <span class="bold table-card-title">
              <slot name="title">Sorteios disponíveis</slot>
            </span>
          </v-col>
          <v-col cols="6" class="d-flex justify-end align-center">
            <mf-status-filter v-if="itemsFilter.length > 1" :items="itemsFilter" @input="getFilterResult" />
          </v-col>
          <v-col cols="3">
            <mf-search v-model="search" class="pt-0 mt-0" hide-details placeholder="Busca" />
          </v-col>
        </v-row>
      </v-card-title>
      <paginated-data-table
        ref="table"
        :headers="headers"
        :query="query"
        :query-variables="queryVariables"
        :search="search"
        queryName="rafflesList"
        :transformFunction="transformFunction"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class="table-text--gray">
              <div class="d-flex align-center colorful-border" :style="{ borderColor: getStatuscolor(item.status) }">
                <div class="py-0 px-4 d-flex align-center">
                  <mf-icon
                    fill
                    :size="item.status === 'processing' ? 12 : 16"
                    :color="getStatuscolor(item.status)"
                    :icon="item.status === 'processing' ? 'processing' : 'fiber_manual_record'"
                    :class="item.status === 'processing' ? 'mr-1' : ''"
                  />
                  {{ getFormatedStatus(item.status) }}
                </div>
              </div>
            </td>
            <!-- <td class="nowrap-row">
              <chip-on-approval v-if="item.on_approval" />
            </td> -->
            <td class="nowrap-row" style="max-width: 300px">
              <v-tooltip v-model="showTooltipTitle[item._id]" max-width="250" top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <router-link class="link" :to="{ path: link(item._id, true) }">
                      {{ item.title | truncate({ length: 70 }) }}
                    </router-link>
                    <!-- <v-menu v-else bottom origin="center center" transition="scale-transition">
                      <template v-slot:activator="innerActivator">
                        <span class="link" v-on="innerActivator.on">{{ item.title | truncate({ length: 70 }) }}</span>
                      </template>
                      <v-list>
                        <v-list-item class="v-list-item--link" @click="redirect(item._id)">
                          <v-list-item-title class="item-option">Editar versão em operação</v-list-item-title>
                        </v-list-item>
                        <v-list-item class="v-list-item--link" @click="redirect(item._id, { onApprovalVersion: true })">
                          <v-list-item-title class="item-option">Editar versão em aprovação</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu> -->
                  </span>
                </template>
                <span>{{ item.title }}</span>
              </v-tooltip>
            </td>
            <td class="nowrap-row">
              <v-tooltip v-model="showTooltipDescription[item._id]" max-width="250" top content-class="truncated-tooltip">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ item.description | truncate({ length: 60 }) }}
                  </span>
                </template>
                <span>{{ item.description }}</span>
              </v-tooltip>
            </td>
            <td class="table-text--gray">{{ item.end_date }}</td>
            <td class="table-text--gray">{{ item.formattedUpdateDate }}</td>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <td>
                  <span v-on="on">
                    <mf-icon v-if="item.show_prize_warning && item.status !== 'DRAFT'" fill color="cinza-l10" size="20" class="ma-0">warning</mf-icon>
                  </span>
                </td>
              </template>
              <span>Há prêmios a serem registrados.</span>
            </v-tooltip>
            <td class="text-right">
              <v-menu class="campaigns-table-actions" bottom origin="center center" transition="scale-transition">
                <template v-slot:activator="{ on }">
                  <mf-button color="cinza-0" icon="more_vert" type="icon" v-on:click.native="on.click" />
                </template>
                <v-list>
                  <v-list-item v-if="item.status !== 'FINISHED'" class="v-list-item--link">
                    <v-list-item-title class="item-option" @click="redirect(item._id)">Editar</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item v-if="item.status !== 'FINISHED' && item.on_approval" class="v-list-item--link">
                    <v-list-item-title class="item-option" @click="redirect(item._id)">Editar versão em operação</v-list-item-title>
                  </v-list-item> -->
                  <!-- <v-list-item v-if="item.status !== 'FINISHED' && item.on_approval" class="v-list-item--link">
                    <v-list-item-title class="item-option" @click="redirect(item._id, { onApprovalVersion: true })"
                      >Editar versão em aprovação</v-list-item-title
                    >
                  </v-list-item> -->
                  <v-list-item class="v-list-item--link" @click="cloneRaffle(item._id, item.title ? item.title : item.name)">
                    <v-list-item-title>Duplicar</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.status === 'SCHEDULED'" class="v-list-item--link" @click="unscheduleRaffle(item)">
                    <v-list-item-title>Suspender</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.status === 'DRAFT'" class="v-list-item--link" @click="deleteRaffle(item._id, item.title)">
                    <v-list-item-title>Apagar rascunho</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </paginated-data-table>
    </v-card>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { mapActions } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import PaginatedDataTable from '@/components/PaginatedDataTable.vue'
import { QUERY_RAFFLES_LIST, MUTATION_DELETE_RAFFLE_DRAFT, MUTATION_CLONE_RAFFLE } from '../../graphql'

export default {
  name: 'RaffleIndexTable',

  components: {
    PaginatedDataTable,
  },

  data: () => ({
    search: '',
    showTooltipTitle: {},
    showTooltipDescription: {},
    DateTime: DateTime,
    statusToSearch: ['ONGOING', 'SCHEDULED', 'FINISHED', 'DRAFT'],
    itemsFilter: [
      { label: 'Ativo', value: 'ONGOING', color: '#0DA740', active: true },
      { label: 'Agendado', value: 'SCHEDULED', color: '#EDB900', active: true },
      { label: 'Concluído', value: 'FINISHED', color: '#0079F2', active: true },
      { label: 'Rascunho', value: 'DRAFT', color: '#6B7580', active: true },
    ],
  }),

  computed: {
    headers() {
      return [
        {
          text: 'Status',
          value: 'status',
          width: '11.5%',
        },
        // {
        //   text: '',
        //   value: '',
        //   sortable: false,
        //   width: '13%',
        // },
        {
          text: 'Título',
          value: 'title',
          width: '24%',
        },
        {
          text: 'Descrição',
          value: 'description',
          width: '24%',
        },
        {
          text: 'Data de validade',
          value: 'end_date',
          width: '17.5%',
        },
        {
          text: 'Última atualização',
          value: 'updated_at',
          width: '12%',
        },
        {
          text: '',
          value: 'prize_warning',
          width: '5%',
          sortable: false,
        },
        {
          text: '',
          value: '',
          sortable: false,
          width: '6%',
        },
      ]
    },
    queryVariables() {
      return {
        status: this.statusToSearch,
      }
    },
    query() {
      return QUERY_RAFFLES_LIST
    },
  },

  mounted() {
    const { cloneRaffleId } = this.$route.params
    if (cloneRaffleId) this.cloneRaffle(cloneRaffleId, null, true)
  },

  methods: {
    ...mapActions(['upsertRaffle', 'setRaffle']),
    getFilterResult(value) {
      this.statusToSearch = value.length ? value : ['ONGOING', 'SCHEDULED', 'FINISHED', 'DRAFT']
    },
    transformFunction(item) {
      const formattedItem = cloneDeep(item)
      const formattedStartDate = DateTime.fromISO(item.start_date).isValid ? DateTime.fromISO(item.start_date).toFormat('dd/MM/yyyy') : ''
      const formattedEndDate = DateTime.fromISO(item.end_date).isValid ? DateTime.fromISO(item.end_date).toFormat('dd/MM/yyyy') : ''
      formattedItem.end_date = `${formattedStartDate} - ${formattedEndDate}`
      formattedItem.formattedUpdateDate = DateTime.fromISO(formattedItem.updated_at.split(' ')[0]).toFormat('dd/MM/yyyy')
      if (!formattedItem.description) {
        formattedItem.description = ''
      }
      formattedItem.show_prize_warning = false
      formattedItem.prizes.forEach((prize) => {
        const currentDate = new Date()
        const prizeDate = new Date(prize.raffle_date)
        if (!prize.given && currentDate > prizeDate) {
          formattedItem.show_prize_warning = true
        }
      })
      return formattedItem
    },

    redirect(_id, { onApprovalVersion = false } = {}) {
      // this.$router.push(`/mobile/sorteios/${_id}?on_approval_version=${onApprovalVersion}`).catch(() => {})
      this.$router.push(`/mobile/sorteios/${_id}`).catch(() => {})
    },

    getStatuscolor(status) {
      switch (status) {
        case 'ONGOING':
          return '#0DA740'
        case 'SCHEDULED':
          return '#EDB900'
        case 'FINISHED':
          return '#0079F2'
        case 'DRAFT':
          return '#6B7580'
        default:
          break
      }
    },

    getFormatedStatus(status) {
      switch (status) {
        case 'ONGOING':
          return 'Ativo'
        case 'SCHEDULED':
          return 'Agendado'
        case 'FINISHED':
          return 'Concluído'
        case 'DRAFT':
          return 'Rascunho'
        default:
          break
      }
    },

    link(param) {
      let path = `/mobile/sorteios/${param}`
      return path
    },

    async deleteRaffle(id, name) {
      const confirmed = await this.$confirm({
        title: 'Remover campanha',
        message: `Tem certeza que deseja remover a campanha "${name}"?`,
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.$refs.table.paginationLoading = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_DELETE_RAFFLE_DRAFT,
          variables: {
            raffle_id: id,
          },
        })
        .then(() => {
          this.$refs.table.waitAndGetData()
        })
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.delete'))
        })
      this.$refs.table.paginationLoading = false
    },

    async cloneRaffle(id, name, skipConfirm = false) {
      if (!skipConfirm) {
        const confirmed = await this.$confirm({
          ...this.$t('campanhas.confirmations.clone'),
          message: `Deseja duplicar ${name ? 'a campanha ' + name.trim().bold() : 'esta campanha'}?`,
        })
          .then(() => true)
          .catch(() => false)
        if (!confirmed) return
      }
      this.$refs.table.paginationLoading = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_CLONE_RAFFLE,
          variables: {
            raffle_id: id,
          },
        })
        .then((response) => {
          this.$router.push(`/mobile/sorteios/${response.data.cloneRaffle._id}`).catch(() => {})
        })
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.delete'))
        })
    },

    async unscheduleRaffle(raffle) {
      try {
        this.setRaffle(raffle)
        const confirmed = await this.$confirm({
          title: 'Suspender sorteio',
          message: 'O sorteio será movido para o status rascunho',
          confirmText: 'Ok',
          cancelText: 'Cancelar',
        })
          .then(() => true)
          .catch(() => false)
        if (!confirmed) return
        const context = {
          apollo: this.$apollo,
          isDraft: true,
        }
        await this.upsertRaffle(context)
        this.$refs.table.waitAndGetData()
        this.$snackbar({ message: 'Sucesso ao suspender campanha', snackbarColor: 'success' })
      } catch (error) {
        console.log(error)
        this.$snackbar({ message: 'Erro ao suspender campanha', snackbarColor: 'error' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.colorful-border {
  border-left: 3px solid;
  height: 100%;
}

tr td:not(:first-child) .colorful-border {
  border: none;
}

::v-deep td:first-child {
  padding: 0 !important;
}
</style>
